import type { LmsFilters, LmsType, LmsTypeFacet } from '@/interfaces/lms';
import { updateListFilter } from '@/lib/utils/lmsQueryParams';
import displayValues from '@/resources/displayValues.json';
import { SimpleCheckboxFilter } from './checkbox/SimpleCheckboxFilter';

type LmsTravelTypeFilterProps = {
    data?: LmsTypeFacet[];
    filters: LmsFilters;
    updateFilters: (key: string, value: string[]) => void;
};

export const LmsTravelTypeFilter = ({ data, filters, updateFilters }: LmsTravelTypeFilterProps) => {
    const options = Object.keys(displayValues.travelType).map((type) => ({
        value: type,
        text: displayValues.travelType[type],
        count: data?.find((facet) => facet.name === type)?.count ?? 0,
    }));

    const onChange = (value: LmsType): void => {
        updateFilters('type', updateListFilter(value, filters.type));
    };

    return <SimpleCheckboxFilter id="travelType" options={options ?? []} checked={filters.type} onChange={onChange} />;
};
